import React from "react";
import Bills from "../../../../static/images/bills-new.svg";
import i18next from 'i18next';
import Card from "canvas-core-react/lib/Card";

export const BlankProviderBillWrapper = ({ condition, children }) => {
  return condition ? <Card>{children}</Card> : <>{children}</>;
};

const BlankProviderBill = ({pendingAccountsCounter = 0}) => {
  return (
    <div
      className={`main ${
        pendingAccountsCounter !== 0 ? "dashboard-blank-bill-provider" : ""
      }`}
    >
      <BlankProviderBillWrapper condition={pendingAccountsCounter !== 0}>
        <img className="billImage" src={Bills} />
        <p className="p-fix">{i18next.t('dashboard.general_message.title')}</p>
        <div className="line"></div>
        <h3>
        {i18next.t('dashboard.general_message.subtitle')}
        </h3>
      </BlankProviderBillWrapper>
    </div>
  );
};

export default BlankProviderBill;
